module.exports = __webpack_public_path__ + "img/lader.770e38c7.jpg";